import React, { useState, useEffect } from 'react';
import firebase from "firebase";
import Login from "./Login";
const database = firebase.firestore();

function Testimonials(props) {

    const [comments, setComments] = useState([])
    const [commentEnviar, setCommentEnviar] = useState("")

    useEffect(()=>{

        database.collection("comments").orderBy("dateTime","desc").onSnapshot(querySnapshot => {

            let aux = [];
            querySnapshot.docChanges().forEach(doc => aux.push(doc.doc.data()));
            setComments( aux);
        })

    },[props.data])

    const logout=()=>{
        firebase.auth().signOut().then(()=> {

        });
    }

    const enviarComment=()=>{
        database.collection("comments").add({
            text: commentEnviar,
            user: firebase.auth().currentUser.displayName,
            email: firebase.auth().currentUser.email,
            dateTime: new Date()
        })
            .then(() => {
                setCommentEnviar("");
                console.log("Comment successfully written!");
            })
            .catch((error) => {
                console.error("Error writing the comment: ", error);
            });
    }

    const handleChangeComment=(event)=>{
        setCommentEnviar(event.target.value);
    }
    const getComments = ()=>{
        if(comments) {
           return comments.map(function (testimonials) {
                return <div>
                    <li key={testimonials.user}>
                        <blockquote>
                            <p>{testimonials.text}</p>
                            <cite>{testimonials.user}</cite>
                            <cite>{testimonials.dateTime.toDate().toLocaleDateString()}</cite>
                        </blockquote>
                    </li>
                </div>
            })
        }
    }


    return (
        <div>


                <section id="testimonials">
                    <div className="text-container">
                        <div className="row section-head">


                            <div className="two columns header-col">
                                <h1><span>Client Testimonials</span></h1>
                            </div>

                            <div className="ten columns flex-container">
                                <ul className="slides">
                                    {getComments()}
                                </ul>
                            </div>
                            {
                                !props.data && <Login />
                            }
                            {props.data && <div className="twelve columns collapsed">
                                <fieldset>
                                <div>
                                    <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                                    <textarea style={{width: "100%"}} rows="10"
                                              id="contactMessage" name="contactMessage"
                                              value={commentEnviar} onChange={handleChangeComment}
                                    ></textarea><div>
                                    <button className="submit" onClick={enviarComment}  >Enviar</button><br/>
                                    <a className="submit" onClick={logout} href="" >Logout</a>
                                    <span id="image-loader">
                                        <img alt="" src="images/loader.gif" />
                                     </span>
                                </div>
                                </div>
                                </fieldset>

                            </div>}
                        </div>
                    </div>
                </section>

        </div>
    )

}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/Components/Testimonials.js